import React from 'react';
import { Link } from 'react-router-dom';

const ProjectSidebarComponent: React.FC = () => {
  return (
    <>
      {/* Projects Section */}
      <div className="mb-5 wow fadeIn" data-wow-delay="0.1s"
        style={{visibility: "visible", animationDelay: "0.1s", animationName: "fadeIn"}}>
        <div className="section-header text-start pb-4">
          <h6 className="h4 fw-bold bg-white px-2 text-uppercase mb-0">Projects</h6>
        </div>
        <div className="service-list d-flex flex-column border-start border-5 border-primary">
          
          {/* Water Treatment Plants */}
          <div className="mb-3">
            <h6 className="fw-bold text-primary p-2 mb-2 bg-light">Water Treatment Plants</h6>
            <Link className="h6 fw-semi-bold bg-light p-3 mb-1 ms-3" to="/raw-water-pre-treatment">Raw Water Pre-treatment</Link>
            <Link className="h6 fw-semi-bold bg-light p-3 mb-1 ms-3" to="/multi-grade-filters-mgf">Multi-Grade Filters (MGF)</Link>
            <Link className="h6 fw-semi-bold bg-light p-3 mb-1 ms-3" to="/activated-carbon-filters-acf">Activated Carbon Filters (ACF)</Link>
            <Link className="h6 fw-semi-bold bg-light p-3 mb-1 ms-3" to="/mixed-bed-units-mb">Mixed Bed Units (MB)</Link>
            <Link className="h6 fw-semi-bold bg-light p-3 mb-1 ms-3" to="/ultra-filtration-uf-plants">Ultra Filtration (UF) Plants</Link>
            <Link className="h6 fw-semi-bold bg-light p-3 mb-1 ms-3" to="/reverse-osmosis-ro-plants">Reverse Osmosis (RO) Plants</Link>
            <Link className="h6 fw-semi-bold bg-light p-3 mb-1 ms-3" to="/desalination-plants">Desalination Plants</Link>
            <Link className="h6 fw-semi-bold bg-light p-3 mb-1 ms-3" to="/electrodeionization-edi">Electrodeionization (EDI)</Link>
          </div>

          {/* Wastewater Treatment Plants */}
          <div className="mb-3">
            <h6 className="fw-bold text-primary p-2 mb-2 bg-light">Wastewater Treatment Plants</h6>
            <Link className="h6 fw-semi-bold bg-light p-3 mb-1 ms-3" to="/effluent-treatment-plants-etps">Effluent Treatment Plants (ETPs)</Link>
            <Link className="h6 fw-semi-bold bg-light p-3 mb-1 ms-3" to="/sewage-treatment-plants-stps">MBBR/MBR/SBR Sewage Treatment Plants (STPs)</Link>
            <Link className="h6 fw-semi-bold bg-light p-3 mb-1 ms-3" to="/multistage-ro-seawater-ro-recycling">Multi-stage RO/Seawater RO Recycling Systems</Link>
            <Link className="h6 fw-semi-bold bg-light p-3 mb-1 ms-3" to="/multi-effect-evaporator-mee-agitated-thin-film-dryer-atfd">Multi Effect Evaporator (MEE)/ATFD</Link>
          </div>

          {/* Chemical & Process Plants */}
          <div className="mb-3">
            <h6 className="fw-bold text-primary p-2 mb-2 bg-light">Chemical & Process Plants</h6>
            <Link className="h6 fw-semi-bold bg-light p-3 mb-1 ms-3" to="/designing-of-industrial-process-piping">Designing of Industrial Process & Piping</Link>
            <Link className="h6 fw-semi-bold bg-light p-3 mb-1 ms-3" to="/pipeline-laying">Pipeline Laying</Link>
            <Link className="h6 fw-semi-bold bg-light p-3 mb-1 ms-3" to="/cooling-towers-enc">Cooling Towers E&C</Link>
            <Link className="h6 fw-semi-bold bg-light p-3 mb-1 ms-3" to="/dairy-plants">Dairy Plants</Link>
            <Link className="h6 fw-semi-bold bg-light p-3 mb-1 ms-3" to="/chemical-plants-reactor-systems">Chemical Plants - Reactor Systems</Link>
          </div>

          {/* BOO Projects */}
          <div className="mb-3">
            <h6 className="fw-bold text-primary p-2 mb-2 bg-light">BOO Projects</h6>
            <Link className="h6 fw-semi-bold bg-light p-3 mb-1 ms-3" to="/boo-build-own-operate-projects">BOO (Build-Own-Operate) Projects</Link>
          </div>

        </div>
      </div>
      
      {/* Download Section */}
      <div className="mb-5 wow fadeIn" data-wow-delay="0.1s"
        style={{visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp"}}>
        <div className="section-header text-start pb-4">
          <h6 className="h4 fw-bold bg-white px-2 text-uppercase mb-0">Download</h6>
        </div>
        <div className="d-flex flex-column">
          <Link className="btn btn-primary fw-semi-bold py-3 mb-3" to=""><i
            className="fa fa-download me-2"></i>Download Project Portfolio (PDF)</Link>
          <Link className="btn btn-primary fw-semi-bold py-3" to=""><i
            className="fa fa-download me-2"></i>Download Technical Specs (PDF)</Link>
        </div>
      </div>
      
      {/* Contact Detail Section */}
      <div className="wow fadeIn" data-wow-delay="0.1s"
        style={{visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp"}}>
        <div className="section-header text-start pb-4">
          <h6 className="h4 fw-bold bg-white px-2 text-uppercase mb-0">Contact Detail</h6>
        </div>
        <div className="bg-dark p-4">
          <div className="d-flex align-items-center mb-4 wow fadeInUp" data-wow-delay="0.1s"
            style={{visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp"}}>
            <div className="bg-primary d-flex align-items-center justify-content-center"
              style={{width: "45px", height: "45px"}}>
              <i className="fa fa-phone-alt text-dark"></i>
            </div>
            <div className="ps-3">
              <p className="text-white mb-1">+012 345 6789</p>
              <p className="text-white mb-0">+012 345 6789</p>
            </div>
          </div>
          <div className="d-flex align-items-center mb-4 wow fadeInUp" data-wow-delay="0.1s"
            style={{visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp"}}>
            <div className="bg-primary d-flex align-items-center justify-content-center"
              style={{width: "45px", height: "45px"}}>
              <i className="fa fa-envelope text-dark"></i>
            </div>
            <div className="ps-3">
              <p className="text-white mb-1">wassertechnochem@hotmail.com</p>
              <p className="text-white mb-0">info@wassertechnochem.com</p>
            </div>
          </div>
          <div className="d-flex align-items-center wow fadeInUp" data-wow-delay="0.1s"
            style={{visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp"}}>
            <div className="bg-primary d-flex align-items-center justify-content-center"
              style={{width: "45px", height: "45px"}}>
              <i className="fa fa-map-marker-alt text-dark"></i>
            </div>
            <div className="ps-3">
              <p className="text-white mb-1">G-219, RIICO Industrial Area</p>
              <p className="text-white mb-0">Palra, Ajmer</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProjectSidebarComponent;
